import {Button, Col, Form, Row, Spinner} from "react-bootstrap";
import {connect, useSelector} from "react-redux";
import {compose} from "redux";
import {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileAlt, faTrash} from "@fortawesome/fontawesome-free-solid";
import {
    getSupplementaryFile,
    supplementaryFileDelete,
    supplementaryFileUpload
} from "../../../../../stores/Admin/Article/actions";

function SupplementaryFiles({
                               articleId,
                               fetchSupplementaryFiles,
                               uploadSupplementaryFile,
                               deleteSupplementaryFile
                           }) {
    const {
        supplementaryFiles,
        isSupplementaryFileUploading,
        isSupplementaryFileUploadingError
    } = useSelector(state => state?.JournalArticleReducer);

    const [values, setValues] = useState({heading: '', file: ''});

    useEffect(() => {
        if (articleId) {
            fetchSupplementaryFiles(articleId)
        }
    }, [articleId]);

    const handleUpload = () => {
        if (!values.file) {
            return;
        }
        const formData = new FormData();
        formData.append('article_id', articleId)
        formData.append('heading', values.heading ?? '')
        formData.append('file', values.file)
        uploadSupplementaryFile(formData)
        setValues({heading: '', file: ''})
    }

    const removeFile = (id) => {
        if (parseInt(id)) {
            deleteSupplementaryFile(id)
        }
    }

    return (
        <div>
            <h5>Supplementary Files</h5>
            <p className="text-muted">Files uploaded by the author are listed below. You can add more or remove
                them.</p>
            <Row className="align-items-end">
                <Col sm={5} className="mb-3">
                    <Form.Label>Heading</Form.Label>
                    <Form.Control
                        value={values?.heading}
                        placeholder="Enter file heading"
                        onChange={e => setValues({...values, heading: e.target.value})}
                    />
                </Col>
                <Col sm={5} className="mb-3">
                    <Form.Label>Upload File</Form.Label>
                    <Form.Control
                        type="file"
                        key={values?.file ? 'has-file' : 'no-file'}
                        accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,video/*"
                        onChange={e => setValues({...values, file: e.target.files[0]})}
                    />
                    <Form.Text className="text-muted">Images / PDF / Docs / Excel / Video allowed</Form.Text>
                </Col>
                <Col sm={2} className="mb-3">
                    {isSupplementaryFileUploading ?
                        <Button variant="primary" type="button" disabled>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/> Adding...
                        </Button>
                        :
                        <Button variant="primary" type="button" onClick={handleUpload}>
                            Add File
                        </Button>
                    }
                </Col>
            </Row>
            {isSupplementaryFileUploadingError &&
                <p className="text-danger">{isSupplementaryFileUploadingError}</p>}
            <table className="table table-bordered">
                <thead>
                <tr>
                    <th>S.No</th>
                    <th>Heading</th>
                    <th>View File</th>
                    <th>Delete</th>
                </tr>
                </thead>
                <tbody>
                {supplementaryFiles?.length > 0 ?
                    supplementaryFiles?.map((supplementary, index) => (
                        <tr key={supplementary?.id}>
                            <td>{index + 1}</td>
                            <td>{supplementary?.heading || `Supplementary File ${index + 1}`}</td>
                            <td><a href={supplementary?.file_path} className="theme_text_color" target="_blank">
                                <FontAwesomeIcon icon={faFileAlt}/> View</a></td>
                            <td><Button variant="danger" size="sm"
                                        onClick={() => removeFile(supplementary?.id)}><FontAwesomeIcon
                                icon={faTrash}/></Button></td>
                        </tr>
                    ))
                    :
                    <tr>
                        <td colSpan={4} className="text-center">No supplementary files.</td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
    )
}

function mapDispatchToProps(dispatch) {
    return {
        fetchSupplementaryFiles: (articleId) => dispatch(getSupplementaryFile(articleId)),
        uploadSupplementaryFile: (data) => dispatch(supplementaryFileUpload(data)),
        deleteSupplementaryFile: (id) => dispatch(supplementaryFileDelete(id)),
    }
}

const withConnect = connect(null, mapDispatchToProps);
export default compose(withConnect)(SupplementaryFiles);
